import { render, staticRenderFns } from "./TMetricDetails.vue?vue&type=template&id=7d5608c4&scoped=true&"
import script from "./TMetricDetails.vue?vue&type=script&lang=js&"
export * from "./TMetricDetails.vue?vue&type=script&lang=js&"
import style0 from "./TMetricDetails.vue?vue&type=style&index=0&id=7d5608c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5608c4",
  null
  
)

/* custom blocks */
import block0 from "./TMetricDetails.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports